import { Component, Inject, Injectable } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

// #region Splash Dialog Component

@Component({
    selector: 'splash-dialog-component',
    template: `
<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>{{message}}</div>
<mat-progress-bar *ngIf="showProgress" mode="indeterminate"></mat-progress-bar>
`
})
export class SplashDialogComponent {
    title: string;
    message: string;
    showProgress: boolean;

    constructor(public dialogRef: MatDialogRef<SplashDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: BaseSplashOptions) {
        this.title = data.TitleText;
        this.message = data.MessageText;
        this.showProgress = data.ShowProgressBar;
    }
}

// #endregion

export class BaseSplashOptions {
    TitleText?: string;
    MessageText?: string;
    ShowProgressBar?: boolean;
}

export { BaseSplashOptions as SplashOptions };

@Injectable({
    providedIn: 'root'
})
export class SplashService {
    private openHandle: MatDialogRef<SplashDialogComponent>;

    constructor(private dialog: MatDialog, private snackbar: MatSnackBar) { }

    // #region Close Splash Method

    CloseSplash() {
        if (this.openHandle) {
            this.openHandle.close();
        }

        this.openHandle = null;
    }

    // #endregion

    // #region Open Splash Method

    OpenSplash(options?: BaseSplashOptions) {
        this.openHandle = this.dialog.open<SplashDialogComponent>(SplashDialogComponent, {
            disableClose: true,
            data: {
                TitleText: 'Please wait',
                MessageText: 'Loading...',
                ShowProgressBar: true,
                ...options
            }
        });

        return this.openHandle.afterOpened();
    }

    // #endregion

    // #region Snackbar Alert Method

    SnackbarAlert(message: string, duration?: number) {
        const config: MatSnackBarConfig = {
            panelClass: ['alert']
        };

        config.duration = (duration != null ? duration : 3500);

        return this.snackbar.open(message, null, config);
    }

    // #endregion

    // #region Snackbar Error Method

    SnackbarError(message: string, duration?: number, hold?: boolean) {
        const config: MatSnackBarConfig = {
            panelClass: ['error']
        };

        let action: string = null;

        if (duration != null) {
            config.duration = duration;
        }

        if (hold === true) {
            action = 'OK';
            config.duration = 5 * 60 * 1000; // 5 minutes?
        }

        return this.snackbar.open(message, action, config);
    }

    // #endregion

    // #region Snackbar Success Method

    SnackbarSuccess(message: string, duration?: number) {
        const config: MatSnackBarConfig = {
            panelClass: ['success']
        };

        config.duration = (duration || 3500);

        return this.snackbar.open(message, null, config);
    }

    // #endregion
}

